export const colors = {
  bgPrimary: '#ffffff',
  textPrimary: '#1a1a18',
  textSecondary: '#5f5e5a',
  textTertiary: '#888780',
  borderTertiary: 'rgba(0,0,0,0.12)',
  accent: '#185FA5',
  activeSuccess: '#2e7d32',
  activeSuccessBg: '#e8f5e9',
};

export const CARD_BORDER_RADIUS = 1;

export function muniDetailInputShellSx() {
  return {
    boxSizing: 'border-box',
    width: '100%',
    m: 0,
    bgcolor: colors.bgPrimary,
    borderRadius: CARD_BORDER_RADIUS,
    borderTopLeftRadius: 0,
    border: '1px solid',
    borderColor: colors.borderTertiary,
  };
}

export const MUNI_INDICATOR_WIDTH = 68;
export const RIGHT_RAIL_GAP = 0.75;
export const RIGHT_RAIL_WIDTH = MUNI_INDICATOR_WIDTH * 2 + 6;

/** Matches 2-row notes field: rows × line-height + vertical padding + border. */
export const MUNI_DETAIL_INPUT_HEIGHT = 'calc(0.875rem * 1.5 * 2 + 12px + 2px)';
